export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9836.2bfcea03.jpg";